'use strict';

module.exports = require('nmr-simulation');



// WEBPACK FOOTER //
// ./index.js